/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const TrustPilotFragment = {
  TrustPilot: gql`
    fragment TrustPilotQuery on trustpilot_Entry {
      dataName
      dataSku
      seo
      showHideTrustpilot
      trustpilotDisplayType
      typeHandle
    }
  `,
};
